import React from 'react';
import { connect } from 'react-redux';
import { IcoCheck } from '../../components/AppShell/icons';
import AppDownloadCard from '../../components/AppDownloadCard';

/**
 * One-time welcome shown right AFTER a trainer completes web profile setup,
 * before their dashboard — the trainer analog of the client's
 * assessment-completed screen. Prompts them to grab the mobile app.
 *
 * Reached only via `/trainer-welcome?welcome=1` (set by TrainerProfileSetup's
 * post-setup redirect). The `?welcome=1` gate (see IndexRoute) makes it a
 * single, one-time hit — a bare visit/refresh bounces to the dashboard.
 *
 * The Nubod app is role-aware: a trainer signs in with their existing account
 * and gets the trainer dashboard/pages, so the copy points them at what they
 * actually do in-app (check in on clients, log sessions, message on the go).
 */
class TrainerWelcome extends React.Component {
  handleContinue = () => {
    this.props.history.push('/dashboard/admin');
  };

  render() {
    const name = this.props.auth?.user?.name;

    return (
      <div
        style={{
          minHeight: 'calc(100vh - 80px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 20px',
          background: 'var(--bg)',
        }}
      >
        <div
          style={{
            maxWidth: 420,
            width: '100%',
            textAlign: 'center',
          }}
        >
          {/* Check mark */}
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'var(--success-soft)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              color: 'var(--success)',
              fontSize: 28,
            }}
          >
            <IcoCheck size={28} />
          </div>

          <h1
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: 'var(--fg)',
              marginBottom: 8,
            }}
          >
            You&apos;re all set{name ? `, ${name}` : ''}!
          </h1>
          <p
            style={{
              fontSize: 14,
              color: 'var(--fg-muted)',
              marginBottom: 40,
              lineHeight: 1.6,
            }}
          >
            Your studio is ready. Build programs, invite clients, and manage
            everything from here — and coach on the go from the Nubod app.
          </p>

          {/* App download card (shared with the client screen) */}
          <AppDownloadCard
            title='Coach from your phone'
            subcopy='Sign in with your trainer account to check in on clients, log their sessions, and message on the go.'
          />

          <button
            className='btn btn-ghost'
            onClick={this.handleContinue}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            Continue to dashboard →
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(TrainerWelcome);
